<section ng-controller="tagDetailsController as tagDetailsCtrl">
    <c-auto-form config="tagDetailsCtrl.autoFormConfig"></c-auto-form>
</section>